export const  POST_SUBSCRIBED_PACKAGE_REQUEST='subscribedPackageReducer/POST_SUBSCRIBED_PACKAGE_REQUEST';
export const  POST_SUBSCRIBED_PACKAGE_SUCCESS='subscribedPackageReducer/POST_SUBSCRIBED_PACKAGE_SUCCESS';
export const  POST_SUBSCRIBED_PACKAGE_FAILED='subscribedPackageReducer/POST_SUBSCRIBED_PACKAGE_FAILED';